import actions from './actions'
import userActions from '../user/actions'

const initialState = {
  loading: false,
  isMFAset: undefined,
  mfa_token: '',
  barcode: '',
  barCodeSecretKey: '',
  twoFAauthModal: false,
}

export default function auth0(state = initialState, action) {
  switch (action.type) {
    case userActions.LOGIN_SUCCESS:
      return {
        ...state,
        mfaToken: action.value ? action.value.mfa_token : '',
        isMFAset: action.value ? action.value.isMFAset : '',
      }
    case userActions.SETUP_MFA_AUTHENTICATOR_SUCCESS:
      return {
        ...state,
        barcode: action.value.barcodeUri,
        barCodeSecretKey: action.value.secret,
      }

    case actions.TWO_FA_AUTHORIZATION_MODAL:
      return {
        ...state,
        twoFAauthModal: action.value,
      }
    default:
      return state
  }
}
